import React, { useCallback, useMemo, useRef,useState } from "react";
import { Card, CardHeader, Row, Col, CardBody } from "shards-react";
import moment from "moment";
import Table from "react-bootstrap/Table";
import CustomPagination from "../common/CustomPagination";
import Pagination from '../common/Pagination';

let PageSize = 10;

export default function ProcessLogs({
  processLogs
}) {

  const [currentPage, setCurrentPage] = useState(1);

  const currentTableData = useMemo(() => {
    const firstPageIndex = (currentPage - 1) * PageSize;
    const lastPageIndex = firstPageIndex + PageSize;
    return processLogs.slice(firstPageIndex, lastPageIndex);
  }, [currentPage, processLogs]);

  return (
    <>
      <Row>
        <Col>
          <Card small className="mb-4">
            <CardHeader className="border-bottom">
              <h6 className="m-0">Process Logs</h6>
            </CardHeader>
            <CardBody className="p-0">
              <Table className="table theme-01 border-bottom" size="sm" responsive>
                <thead className="bg-light">
                  <tr>
                    <th scope="col" className="border-0">
                      Batch
                    </th>
                    <th scope="col" className="border-0">
                      Process Name
                    </th>
                    <th scope="col" className="border-0">
                      Log Date
                    </th>
                    {/* <th scope="col" className="border-0">
                      UKey File
                    </th> */}
                    <th scope="col" className="border-0">
                      Message
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {currentTableData.length ? (
                    currentTableData.map((item, index) => (
                      <tr className="clickable" key={index.toString()}>
                        <td>{item.batchRportId}</td>
                        <td>{item.processName}</td>
                        <td>{moment(new Date(item.logDate)).format("DD/MM/yyyy hh:mm:ss A")}</td>
                        {/* <td>{item._id}</td> */}
                        <td>{item.message}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5" className="text-center">
                        No Data
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>

              
              <div className="flx-content-right">
                <Pagination
                  className="pagination-bar"
                  currentPage={currentPage}
                  totalCount={processLogs.length}
                  pageSize={PageSize}
                  onPageChange={page => setCurrentPage(page)}
                />
                {/* <CustomPagination data={processLogs} setData={this.setPagedLogData} pageSize={5} /> */}
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </>
  );

}

